//TODO: Do the same ops with cldr instead of these
/**
 * @deprecated
 * Prefer using phensley/cldr for handling numerical operations whenever possible.
 * This class serves as a fallback solution for specific edge cases.
 */
export class NumberUtils {
    /**
     * Converts ########.### to #m.##
     * Converts ####.### to #k.##
     * @param num
     */
    static formatNumberToMK(num: number): string {
        if (num >= 1000000 || num <= -1000000) {
            return (num / 1000000).toFixed(2) + 'm';
        } else if (num >= 1000 || num <= -1000) {
            return (num / 1000).toFixed(2) + 'k';
        } else {
            return num.toFixed(2);
        }
    }
    /**
     * Converts ####### to # ### ###
     * @param inputNumber
     */
    static formatNumberToSeperated(number: number): string {
        const numberString = number.toFixed(0);
        let formattedNumber = '';
        for (let i = numberString.length - 1; i >= 0; i--) {
            formattedNumber = numberString[i] + formattedNumber;
            if ((numberString.length - i) % 3 === 0 && i !== 0) {
                formattedNumber = ' ' + formattedNumber;
            }
        }
        return formattedNumber;
    }
    /**
     * Converts # ### ### to #######
     * @param inputNumber
     */
    static parseNumberFromSeperated(input: any): number {
        if (typeof input === 'number') {
            return input;
        }
        if (typeof input !== 'string') {
            return NaN;
        }
        // remove all spaces
        const numberString = input.replace(/\s/g, '');
        // convert the remaining part to a number
        const value = parseFloat(numberString);
        if (isNaN(value)) {
            return NaN;
        }
        return value;
    }
    /**
     * Converts #m.## to ########.###
     * Converts #k.## to ####.###
     * @param num
     */
    static parseNumberFromMK(input: string): number {
        if (typeof input !== 'string') {
            return NaN;
        }
        const lowerCaseInput = input.toLowerCase();
        let multiplier = 1;
        if (lowerCaseInput.endsWith('m')) {
            multiplier = 1000000;
        } else if (lowerCaseInput.endsWith('k')) {
            multiplier = 1000;
        }
        // remove the last character (k or m) and convert the remaining part to a number
        const value = parseFloat(lowerCaseInput.slice(0, -1));
        if (isNaN(value)) {
            return NaN;
        }
        return value * multiplier;
    }
    static sumSeperatedNumbers(res: any[], seperatedNumber: string) {
        return NumberUtils.formatNumberToSeperated(
            res.reduce((sum, item) => {
                const value = NumberUtils.parseNumberFromSeperated(item[seperatedNumber]);
                if (isNaN(value)) {
                    return sum; // Skip this value
                }
                return sum + value;
            }, 0)
        );
    }
}
